import { css } from '@recruit-robin/robin-theme/web-styles';

export const dropdownCss = css`
  width: 100%;
`;

export const menuCss = css`
  z-index: 3;
  width: 100%;
  max-width: 472px;
  min-width: 250px;
`;
